import { forwardRef, useContext } from "react";
import CardHeader from "../card/cardHeader";
import { ModalContext } from "./modalContext";
import Button from "../button";
import { X } from "lucide-react";
import { twMerge } from "tailwind-merge";
import clsx from "clsx";

export interface ModalHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  closeButton?: boolean;
}

const ModalHeader = forwardRef<HTMLDivElement, ModalHeaderProps>(
  (props, ref) => {
    const { children, className, closeButton, ...rest } = props;
    const { onClose } = useContext(ModalContext);

    return (
      <CardHeader
        {...rest}
        ref={ref}
        className={twMerge(
          clsx({
            "flex items-center gap-2": !!closeButton,
          }),
          className
        )}
      >
        {children}
        {closeButton && (
          <Button variant="light" size="sm" onClick={onClose}>
            <X size="16" />
          </Button>
        )}
      </CardHeader>
    );
  }
);

export default ModalHeader;
